import React, {
  useMemo,
  memo
} from "react";
import {
  StyleSheet
} from "react-native";
import {
  Card
} from "@constants/Themed";
import ActivityLineChart from "@components/Charts/ActivityLineChart";
import {
  getLineChartConfig,
  MODERN_CHART_COLORS
} from "@utils/chartTheme";
import {
  themeSelector
} from "@reduxLocal/selectors/themeSelector";

interface ActivityLineChartWidgetProps {
  isLoading: boolean;
  width: number;
  height: number;
}

const ActivityLineChartWidget: React.FC<ActivityLineChartWidgetProps> = ({
  isLoading,
  width,
  height,
}) => {
  const theme = themeSelector();
  const lineChartConfig = useMemo(
    () => getLineChartConfig("modern", theme), [theme]
  );

  const activityData = useMemo(
    () => ({
      labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      datasets: [{
        data: Array.from({
          length: 7
        }, () => Math.floor(Math.random() * 50) + 20),
        color: (opacity = 1) =>
          `${MODERN_CHART_COLORS.line.primary}${Math.round(opacity * 255)
            .toString(16)
            .padStart(2, "0")}`,
        strokeWidth: 3,
      },],
    }), []
  );

  return (
    <Card style={styles.card}>
      <ActivityLineChart
        data={activityData}
        isLoading={isLoading}
        chartConfig={lineChartConfig}
        width={width}
        height={height}
      />
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    width: "100%",
    height: "100%",
    borderRadius: 15,
    overflow: "hidden",
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});

export default memo(ActivityLineChartWidget);
